/* js/ajax-pagination.js */

;(function($, window, document) {
    
    $(document).ready(function(){
        
        var newsContainerCls = '.news--teaser-container',
        newsItemCls = newsContainerCls + ' > .blog-list__container',
        $_pagination = $(newsContainerCls + ' .pagination'),
        //$_newsDetailSelect = $('.view--news-detail .news--categories-select'),
        $_btn = null,
        $loader = null,
        _nextUrl = null;
        
        var getNewsItems = function ($url) {

        // Add loader animation
        // addLoaderAnimation();

        // Make the actual ajax request
        $.ajax($url, {
            method: 'GET',
            dataType: 'html',
            error: function (jqXHR, textStatus, errorThrown) {
                console.log('AJAX :: error');
                console.log(errorThrown);
            },
            success: function (data, textStatus, jqXHR) {
                var $data = $(data),
                    $newsItems = $data.find(newsItemCls);

                // Add news items to container
                $newsItems.insertAfter($(newsItemCls).last());

                // Update pagination url
                var $nextUrl = $data.find(newsContainerCls + ' .pagination .next > a');

                if ($nextUrl.length > 0) {
                    _nextUrl = $nextUrl.attr('href');
                    $('.pagination').show();
                } else {
                    // Remove pagination, cuz there are no news left..
                    $('.pagination').hide();
                }

                // Remove loader animation
                // $loader.detach();

                // Re-enable 'load more' button
                $('.pagination button').prop('disabled', false);
            }

        });
    };

    var getNextUrl = function ($pagination) {
        var $next = $pagination.find('.next');
        if ($next.length > 0) {
            return $next.find('a').attr('href');
        } else {
            return null;
        }
    };

    var loadNext = function () {

        if (_nextUrl === null) {
            _nextUrl = getNextUrl($_pagination);
        }

        if (_nextUrl !== null) {
            getNewsItems(_nextUrl);
        } else {
            console.log('no next pages available');
        }

    };

    var addAjaxPagination = function () {
        $_btn = $('<button type="button" class="button button--primary" title="weitere Beiträge laden">mehr laden</button>').on('click', function () {
            $(this).prop("disabled", true);
            loadNext();
        });
        $_btn.appendTo($_pagination);
    };

    if ($_pagination.length > 0) {
        addAjaxPagination();
    }
    
    function loadCategoryContent(href) {

        // Add loader animation
        addLoaderAnimation();

        // Make the actual ajax request
        $.ajax(href, {
            method: 'GET',
            dataType: 'html',
            error: function (jqXHR, textStatus, errorThrown) {
                console.log('AJAX :: error');
                console.log(errorThrown);
            },
            success: function (data, textStatus, jqXHR) {

                var $data = $(data),
                    $newsItems = $data.find(newsItemCls);

                // Add items
                $(newsContainerCls).quicksand($newsItems, {
                    duration: 1000,
                    adjustHeight: 'dynamic',
                }, function () {
                    // Update pagination url
                    var $nextUrl = $data.find(newsContainerCls + ' .pagination .next > a');

                    if ($nextUrl.length > 0) {
                        _nextUrl = $nextUrl.attr('href');
                        $_pagination.appendTo(newsContainerCls);
                        $_pagination.on('click', function () {
                            loadNext();
                        }).show();
                    } else {
                        // Remove pagination, cuz there are no news left..
                        $_pagination.hide();
                    }

                    // Update container height
                    $(newsContainerCls).css({'height': 'initial'});
                    $('.pagination').css({'width': 'auto'});

                });

                // Remove loader animation
                //$loader.detach();

                // Re-enable 'load more' button
                $_btn.prop('disabled', false);
            }

        });
    }
        
    });
    
})(jQuery, window, document); 